
// import './App.css';
import { useEffect, useState } from 'react';
import { getAssessment } from './../services/api';
import AssessmentsTable from '../components/assessmentsTable';
import AssessmentSectionsTable from '../components/assessmentSectionsTable';
import { useParams } from 'react-router-dom'

function Assessment({  }) {
    let { id } = useParams();

    return (
        <div>
            <header className="App-header">
                Assessment
            </header>
            <span>Select the assessment2 to edit, or click create to start a new one</span>
            <AssessmentSectionsTable assessmentId={id}></AssessmentSectionsTable>
        </div>
    );
}

export default Assessment;
